export default __webpack_public_path__ + "static/media/640_dummy2016-fotograf03-mobile-de.56d9bd00.png";